export const GET_COORDINATES_PENDING = 'getCoordinatesMapPending';
export const GET_COORDINATES_FULFILLED = 'getCoordinatesMapFulfilled';
export const GET_COORDINATES_REJECTED = 'getCoordinatesMapRejected';
export const MAP_TYPES = {1 : 'satellite', 2 : 'roadmap', 4 : 'terrain', 16 : 'hybrid'}
